import React from 'react';
import PropTypes from 'prop-types';
import ProfileIcon from 'components/ProfileIcon';
import './HeaderProfileIcon.css';

function HeaderProfileIcon({ user, onClick, size = 40, showName = true }) {
  return (
    <div className="header-profile-icon">
      <div className="profile-icon-wrapper">
        <div className="profile-icon-bg" aria-hidden={!!showName}>
          <ProfileIcon
            onClick={onClick}
            size={size}
            avatarData={user && user.avatarData}
            withBorder
            alt="Go to profile"
          />
        </div>
        {showName && (
          <button
            type="button"
            onClick={onClick}
            className="profile-name-link"
            aria-label="Go to profile"
            title={user.displayName}
          >
            {user.displayName}
          </button>
        )}
      </div>
    </div>
  );
}

HeaderProfileIcon.propTypes = {
  user: PropTypes.shape({
    avatarUrl: PropTypes.string,
    displayName: PropTypes.string
  }),
  onClick: PropTypes.func,
  size: PropTypes.number,
  showName: PropTypes.bool
};

export default HeaderProfileIcon;
